import CheckIcon from '@mui/icons-material/Check';
import BlockIcon from '@mui/icons-material/Block';
import { CircularProgress, IconButton } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';

import Role from 'entities/role/model';
import { red } from 'utils/color-styles';
import Organizer from 'entities/organizer/model';

import { updateAction } from './actions';
import { selectUpdating } from './selectors';
interface Props {
  user: Organizer;
  roles: Map<string, Role>;
}

// @TODO-DP: this is copy-paste from VolunteersTables. We should give this component proper design and then extract it to be a reusable component.
const useStyles = makeStyles({
  button: {
    padding: '7px 8px',
    minWidth: 64,
    fontSize: '0.8125rem',
    minHeight: 32,
  },
  accepted: {
    color: '#000 !important',
  },
  rejected: {
    color: `${red} !important`,
  },
  pendingAccept: {
    color: 'rgba(0, 0, 0, 0.3) !important',
    '&:hover': {
      color: '#000 !important',
    },
  },
  pendingReject: {
    color: 'rgba(0, 0, 0, 0.3) !important',
    '&:hover': {
      color: `${red} !important`,
    },
  },
});

export const ActionButtons = ({ user, roles }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isUpdating = useSelector((state) => selectUpdating(state, user.id));

  const hasOnlyBlockedRole = Boolean(
    user.roles.find((roleId) => !!roleId && roles.get(roleId)?.code === 'Blocked') &&
      user.roles.size === 1
  );
  const hasNoRoles = user.roles.size === 0 && user.type !== 'Admin';
  const isBlocked = hasOnlyBlockedRole || hasNoRoles;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 4,
        paddingRight: 4,
        height: 36,
      }}
    >
      {isUpdating ? (
        <CircularProgress size={24} />
      ) : (
        <>
          <IconButton
            title="Approve"
            disabled={!isBlocked}
            onClick={() => dispatch(updateAction(user.id, true))}
            classes={{
              root: isBlocked ? classes.pendingAccept : '',
              disabled: classes.accepted,
            }}
          >
            <CheckIcon />
          </IconButton>
          <IconButton
            title="Reject"
            disabled={isBlocked}
            onClick={() => dispatch(updateAction(user.id, false))}
            classes={{
              root: !isBlocked ? classes.pendingReject : '',
              disabled: classes.rejected,
            }}
          >
            <BlockIcon />
          </IconButton>
        </>
      )}
    </div>
  );
};
